import { render, staticRenderFns } from "./DatasetGroupManage.vue?vue&type=template&id=2e6634c9&scoped=true"
import script from "./DatasetGroupManage.vue?vue&type=script&lang=js"
export * from "./DatasetGroupManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6634c9",
  null
  
)

export default component.exports